import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LandingContentCard = ({ textContent, linkAddress }) => (
  <div className=" bg-white hover:bg-gray-50 cursor-pointer shadow-lg flex p-4 flex-row items-center justify-items-center">
    <span className="flex-grow">{textContent}</span>
    <span className="flex-grow-0">
      <button className="lg:hidden ml-3">
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
      <button
        title={linkAddress}
        className="hidden lg:inline w-32 py-2 whitespace-nowrap uppercase font-bold font-sm bg-red-500 hover:bg-red-600 text-white"
      >
        Let's Go <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </span>
  </div>
);

export default LandingContentCard;
